import * as React from 'react';

import { ENTITY_TYPE_TO_ENTITY_CARDS_MAPPING } from 'bundles/unified-seo-content-common/components/entity-cards';
import { ENTITY_TYPES } from 'bundles/unified-seo-content-common/constants';
import type { EntityCardInputProps } from 'bundles/unified-seo-content-common/types';

type Props = {
  entityCardMetadata: EntityCardInputProps;
};

const EntityCardDelegator = ({ entityCardMetadata }: Props) => {
  const { entityType, slug } = entityCardMetadata;

  if (!slug) {
    return null;
  }

  const {
    course: CourseCard,
    s12n: S12nCard,
    profS12n: ProfS12nCard,
    project: ProjectCard,
    degree: DegreeCard,
    mastertrack: MasterTrackCard,
  } = ENTITY_TYPE_TO_ENTITY_CARDS_MAPPING;

  switch (entityType) {
    case ENTITY_TYPES.course:
      return <CourseCard {...entityCardMetadata} entityType={ENTITY_TYPES.course} />;

    case ENTITY_TYPES.s12n:
      return <S12nCard {...entityCardMetadata} entityType={ENTITY_TYPES.s12n} />;

    case ENTITY_TYPES.profS12n:
      return <ProfS12nCard {...entityCardMetadata} entityType={ENTITY_TYPES.profS12n} />;

    case ENTITY_TYPES.project:
      return <ProjectCard {...entityCardMetadata} entityType={ENTITY_TYPES.project} />;

    case ENTITY_TYPES.degree:
      return <DegreeCard {...entityCardMetadata} />;

    case ENTITY_TYPES.mastertrack:
      return <MasterTrackCard {...entityCardMetadata} />;

    default:
      return <CourseCard {...entityCardMetadata} entityType={ENTITY_TYPES.course} />;
  }
};

export default EntityCardDelegator;
